export default __webpack_public_path__ + "static/media/leaderboard-info.47204f43.pdf";